var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"hide-details":"","outlined":"","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-select',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }